export function filterSearchIndex(str: string) {
  const replaceList = [
    /<searchIndex index="\d+" \/>/gi,
    /<ciIndex index=['"]\d+['"]\s*\/>/gi,
    /<productIndex index="\d+" \/>/gi,
  ];
  return replaceList.reduce((prev, reg) => prev.replace(reg, ''), str);
}

/**
 * 移除<think>标签及其内容，只保留标签后的文本
 * 例如：'<think>aaaa</think>bbb' => 'bbb'
 * 如果只有单独的<think>或</think>标签，则只移除这些标签
 */
export function filterThinkContent(str: string) {
  if (!str) return '';

  // 先移除完整的<think>...</think>标签及其包含的内容
  let result = str.replace(/<think>[\s\S]*?<\/think>/g, '');

  // 再移除单独的<think>或</think>标签
  result = result.replace(/<\/?think>/g, '');

  return result;
}
